import { css } from '@emotion/react';

const icons = [
    "draft",
    "new-req",
    "json-array",
    "json-boolean",
    "json-null",
    "json-number",
    "json-other",
    "json-string",
    "json-object"
];

export default $ => css`
  .flip-h {
    transform: scaleX(-1);
    &.flip-v {
      transform: scale(-1, -1);
    }
  }
  .flip-v {
    transform: scaleY(-1);
  }

  .badged-icon {
      position: relative;

      > .fa {
          font-size: inherit;
      }

      > .large-red-badge {
          font-size: 0.6em;
          position: absolute;
          top: 0.5em;
          left: 0.2em;
          border-radius: 50%;
          min-width: 1.1em;
          line-height: 1.1em;
          text-align: center;
          color: red;
      }
  }

  .icon:not(option) {

      &::before {
          display: inline-block;
          background-repeat: no-repeat;
          background-size: ${$.iconHeight * 0.9} ${$.iconHeight * 0.9};
          background-position-x: center;
          background-position-y: center;
          width: ${$.iconHeight};
          height: ${$.iconHeight};
          line-height: 1em;
          vertical-align: middle;
          content: " ";
          margin-right: 4px;
      }

      ${icons.map(icon => `
        &.icon-${icon}::before {
            background-image: url("../images/${icon}.svg");
        }
      `).join('')}
      
      &.icon-new-req::before {
          transform: translateY(${$.iconHeight * 0.2});
      }
  }

  option.icon {
      background-repeat: no-repeat;
      background-size: ${$.iconHeight * 0.9} ${$.iconHeight * 0.9};
      background-position-x: center;
      background-position-y: center;

      ${icons.map(icon => `
        &.icon-${icon} {
            background-image: url("../images/${icon}.svg");
        }
      `).join('')}
  }
`;
